import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_REPORTS = API_URL_VERSION + "relatorios";
export const ENDPOINT_REPORTS_LIST = ENDPOINT_REPORTS + "/qualitativo-infracoes-lista";
export const ENDPOINT_REPORTS_EXPORT = ENDPOINT_REPORTS + "/qualitativo-infracoes-exportar";
export const ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_AGENTS_MONTH = ENDPOINT_REPORTS + "/quantitativo-infracoes-agentes-mes-exportar";
export const ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_EQUIPMENT_MONTH = ENDPOINT_REPORTS + "/quantitativo-infracoes-equipamentos-mes-exportar";
export const ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_TYPES_MONTH = ENDPOINT_REPORTS + "/quantitativo-infracoes-tipos-mes-exportar";
export const ENDPOINT_REPORTS_EXPORT_USERS = ENDPOINT_REPORTS + "/exportar-usuarios";
export const ENDPOINT_REPORTS_EXPORT_PERMITTEE_SITUATION = ENDPOINT_REPORTS + "/exportar-situacao-permissionarios";
export const ENDPOINT_REPORTS_EXPORT_UNCONFIRMED_RADAR_FINES = ENDPOINT_REPORTS + "/exportar-multas-nao-confirmadas-radar";
export const ENDPOINT_REPORTS_AGENTS_TRACKING = ENDPOINT_REPORTS + "/rastreamento-agentes";
export const ENDPOINT_REPORTS_QUANTITATIVE_PERMITTEES_DOCUMENTS_MONTH = ENDPOINT_REPORTS + "/quantitativo-documentos-permissionarios-mes-exportar";
export const ENDPOINT_REPORTS_EXPORT_FINES_PAID_PER_MONTH_YEAR_DETRAN = ENDPOINT_REPORTS + "/exportar-multas-pagas-por-mes-ano-detran";
export const ENDPOINT_REPORTS_EXPORT_VALUES_INFRACTIONS_RECEIVED_MONTH = ENDPOINT_REPORTS + "/valores-infracoes-a-receber-mes-exportar";
export const ENDPOINT_REPORTS_EXPORT_FINES_PAID_PER_MONTH_YEAR_BANK = ENDPOINT_REPORTS + "/exportar-multas-pagas-por-mes-ano-banco";
export const ENDPOINT_REPORTS_EXPORT_SUMMARY_VALUES_INFRACTIONS = ENDPOINT_REPORTS + "/resumo-valores-infracoes-exportar";
export const ENDPOINT_REPORTS_MANAGERIAL = ENDPOINT_REPORTS + "/gerencial-json";

export const reportsService = {
  list: async (params = {}) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.post(ENDPOINT_REPORTS_LIST, searchParams);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "reports.violations-qualitative.messages.errors.list";
    }
  },

  managerial: async (params = {}) => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_MANAGERIAL, {
        params: params,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "reports.managerial.messages.errors.list";
    }
  },

  export: async (params = {}) => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT, {
        params,
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  exportUsers: async () => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT_USERS, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  exportPermitteeSituation: async () => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT_PERMITTEE_SITUATION, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  exportUnconfirmedRadarFines: async () => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT_UNCONFIRMED_RADAR_FINES, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  getAgentsTracking: async (params) => {
    try {
      const response = await api.get(`${ENDPOINT_REPORTS_AGENTS_TRACKING}`, {
        params,
      });

      return response;
    } catch (error) {
      throw error.response?.data?.message || "reports.agent-tracking.messages.errors.list";
    }
  },

  exportMonthlyPermitteeDocuments: async (params) => {
    try {
      return await api.get(
        ENDPOINT_REPORTS_QUANTITATIVE_PERMITTEES_DOCUMENTS_MONTH,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  },

  exportFinesPaidPerMonthYearDetran: async () => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT_FINES_PAID_PER_MONTH_YEAR_DETRAN, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  exportFinesPaidPerMonthYearBank: async () => {
    try {
      const response = await api.get(ENDPOINT_REPORTS_EXPORT_FINES_PAID_PER_MONTH_YEAR_BANK, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "system.messages.errors.export";
    }
  },

  exportValuesInfractionsToBeReceivedMonth: async (params) => {
    try {
      return await api.get(
        ENDPOINT_REPORTS_EXPORT_VALUES_INFRACTIONS_RECEIVED_MONTH,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  },

  exportSummaryValuesInfractions: async (params) => {
    try {
      return await api.get(
        ENDPOINT_REPORTS_EXPORT_SUMMARY_VALUES_INFRACTIONS,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  },

  exportQuantitativeInfractionsAgentsMonth: async (params) => {
    console.log(params);
    try {
      return await api.get(
        ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_AGENTS_MONTH,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  },

  exportQuantitativeInfractionsEquipmentMonth: async (params) => {
    try {
      return await api.get(
        ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_EQUIPMENT_MONTH,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  },

  exportQuantitativeInfractionsTypesMonth: async (params) => {
    try {
      return await api.get(
        ENDPOINT_REPORTS_EXPORT_QUANTITATIVE_INFRACTIONS_TYPES_MONTH,
        {
          responseType: "blob",
          params,
        }
      );
    } catch (error) {
      throw (
        error.response?.data?.message || "system.messages.errors.export"
      );
    }
  }

};
